import React from "react";
import LeftSide from "../../sides/LeftSide";
import { connect } from "react-redux";
import { fetchResults } from "../../../redux/actions/resultActions";
import MidSideFilter from "./MidSideFilter";
import moment from "moment/moment";
import RightSideFilter from "../../sides/RightSideFilter";

const FilterMT = ({ ...props }) => {
  const onChangeDate = (value) => {
    window.location.href =
      "/ket-qua-xo-so/" + moment(value).format("DD-MM-yyyy") + ".html";
  };
  const {
    drawResult: { data },
  } = props;
  return (
    <div className="dnw-content-layout">
      <div className="dnw-content-main" id="dnw-content-main">
        <div className="dnw-content-main-l">
          <div className="dnw-content-main-r">
            <table cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <LeftSide
                    {...props}
                    onChangeDate={(date) => onChangeDate(date)}
                  />
                  <MidSideFilter
                    {...props}
                    draw={data}
                    onChangeDate={(date) => onChangeDate(date)}
                  />
                  <RightSideFilter />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  results: state.result.resultHistory,
  drawResult: state.result.draw,
});

export default connect(mapStateToProps, {
  fetchResults,
})(FilterMT);
